"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chatQueryService = void 0;
var _lodash = require("lodash");
var _constants = require("../constants");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var chatQueryService = function () {
  var getChatMembersFilter = function getChatMembersFilter(_ref) {
    var _ref$type = _ref.type,
      type = _ref$type === void 0 ? _constants.MESSAGING_CHAT_CHANNEL_TYPE : _ref$type,
      _ref$members = _ref.members,
      members = _ref$members === void 0 ? [] : _ref$members,
      disabled = _ref.disabled;
    if (members.length > 1) {
      var generatedFilter = [];
      for (var i = 0; i < members.length; i++) {
        generatedFilter.push({
          type: type,
          members: {
            $in: [members[i]]
          }
        });
      }
      return {
        $and: generatedFilter
      };
    }
    return {
      type: type,
      members: (0, _lodash.isEmpty)(members) ? undefined : {
        $in: members
      },
      disabled: disabled
    };
  };
  function queryChannels(_x) {
    return _queryChannels.apply(this, arguments);
  }
  function _queryChannels() {
    _queryChannels = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var client, _ref2$filter, filter, _ref2$sort, sort, _ref2$options, options;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              client = _ref2.client, _ref2$filter = _ref2.filter, filter = _ref2$filter === void 0 ? {} : _ref2$filter, _ref2$sort = _ref2.sort, sort = _ref2$sort === void 0 ? {
                last_message_at: -1
              } : _ref2$sort, _ref2$options = _ref2.options, options = _ref2$options === void 0 ? {} : _ref2$options;
              _context.next = 3;
              return client === null || client === void 0 ? void 0 : client.queryChannels(filter, sort, options);
            case 3:
              _context.t0 = _context.sent;
              if (_context.t0) {
                _context.next = 6;
                break;
              }
              _context.t0 = [];
            case 6:
              return _context.abrupt("return", _context.t0);
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _queryChannels.apply(this, arguments);
  }
  function queryActiveChannel(_x2) {
    return _queryActiveChannel.apply(this, arguments);
  }
  function _queryActiveChannel() {
    _queryActiveChannel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
      var client, members, filter, _yield$queryChannels, _yield$queryChannels2, activeChannel;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              client = _ref3.client, members = _ref3.members;
              filter = getChatMembersFilter({
                members: members
              });
              _context2.next = 4;
              return queryChannels({
                client: client,
                sort: {},
                filter: filter
              });
            case 4:
              _yield$queryChannels = _context2.sent;
              _yield$queryChannels2 = _slicedToArray(_yield$queryChannels, 1);
              activeChannel = _yield$queryChannels2[0];
              return _context2.abrupt("return", activeChannel);
            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _queryActiveChannel.apply(this, arguments);
  }
  return {
    queryChannels: queryChannels,
    queryActiveChannel: queryActiveChannel,
    getChatMembersFilter: getChatMembersFilter
  };
}();
exports.chatQueryService = chatQueryService;